import React from "react";
import RichText from "components/rich-text";
import RenderAccordions from "../details/accordions";
import AddToCart from "components/add-to-cart";
import WithCollaboration from "../details/with-collaboration";
import ReviewsWidget from "utils/reviews";
import BundleProducts from "components/bundle-products";
import { useSelector } from "react-redux";
import ProductPrices from "../prices";
import { useGlobalContext } from "context/global";
import extractIdFromGid from "helpers/extract-gid";
import SubscriptionQuantityInput from "components/subs-quantity-input";
import clsx from "clsx/lite";
import PricePerKg from "components/price-per-kg";

const ProductPageDetails = ({ product }) => {
	const {
		accordions = [], nutrients = {}, tags = [], description = [],
		collaboration, products = [], total_bundle_products = 0,
	} = product.details ?? {};

	const { translation } = useGlobalContext();
	const { activeBox } = useSelector((state) => state.cart);
	const { subscriptionId, draftChanges } = useSelector((state) => state.account.subscription);

	let price = product?.variant?.price;

	if (product?.variant?.weight && activeBox?.discount > 0)
		price -= activeBox.discount;

	return (
		<div className="md:px-14">
			<div className="flex flex-col mt-10">
				<h1 className="text-h2-xs md:text-h2 font-heading">{product.title}</h1>
				<ReviewsWidget sku={product?.variant?.sku} position="left" />

				<div className="text-left my-6">
					<RichText value={description} />
				</div>

				<div className="flex gap-2 items-center text-lg">
					<ProductPrices variant={product.variant} className="text-lg font-black" />
					{product.details?.weight ? ` / ${product.details?.weight}g` : ""}
				</div>

				<PricePerKg price={price} weight={product.details?.weight} />
			</div>
			<div className={clsx("flex justify-start mb-10 mt-5", draftChanges.isSyncing && "ml-4")}>
				{subscriptionId ?
					price === 0 ? <></> :
						<SubscriptionQuantityInput
							productVariantId={extractIdFromGid(product?.variant?.id)}
							stock={product?.variant?.stock}
							product={product}
							addClassName="!w-fit px-8 !py-4 !btn-primary"
							containerClass="!mx-0" /> :
					<AddToCart product={product} openCart showLoader className="w-3/4 md:w-1/2" />}
			</div>

			<h2 className="text-xl">{translation?.product?.aboutTheProduct}</h2>
			{tags.length > 0 && (
				<div className="flex flex-row justify-start py-2.5 flex-wrap my-5">
					{tags.map((tag, idx) => (
						<span className="tag" key={idx}>
							{tag}
						</span>
					))}
				</div>
			)}

			{collaboration && <WithCollaboration collaboration={collaboration} />}

			<div className="flex flex-row justify-between md:pt-6 pb-4 px-4">
				{Object.keys(nutrients)
					.filter((k) => k !== "_type")
					.map((key) => (
						<div key={key} className="flex flex-col text-center w-[22%]">
							<span className="text-small uppercase text-secondary-darker tracking-widest">{key}</span>
							<span className="text-body mt-1.5">{nutrients[key]}</span>
						</div>
					))}
			</div>

			{product?.type === "Custom Bundle" && total_bundle_products > 0 &&
				<BundleProducts products={products} total={total_bundle_products} />}

			<div className="pb-10 pt-2.5">
				<RenderAccordions accordions={accordions} />
			</div>
		</div>
	);
};

export default ProductPageDetails;
